import { supabase } from "@/integrations/supabase/client";

export async function sendLoopsEvent(
  email: string,
  eventName: string,
  contactProperties?: Record<string, any>,
  eventProperties?: Record<string, any>
) {
  const { data, error } = await supabase.functions.invoke("loops-event", {
    body: { email, eventName, contactProperties, eventProperties },
  });
  if (error) {
    console.error("Loops event error:", error);
  }
  return data;
}

export async function upsertLoopsContact(
  email: string,
  properties?: Record<string, any>
) {
  const { data, error } = await supabase.functions.invoke("loops-event", {
    body: { action: "upsert", email, contactProperties: properties },
  });
  if (error) {
    console.error("Loops upsert error:", error);
  }
  return data;
}

export async function sendLoopsTransactional(
  email: string,
  transactionalId: string,
  dataVariables?: Record<string, any>
) {
  const { data, error } = await supabase.functions.invoke("loops-event", {
    body: { action: "transactional", email, transactionalId, dataVariables },
  });
  if (error) {
    console.error("Loops transactional error:", error);
  }
  return data;
}
